export default {
    hiddenTeamMembers: 'Hidden Team Members',
    moreReviewersPill: 'And {{count}} more reviewers',
    removeReviewer: 'Remove {{name}}',
};
